// extracted by mini-css-extract-plugin
export default {"container":"jN1VR","image":"TkOm2","desktop":"EpzxD","mobile":"DFXJz","imageFit":"xiwKz"};